var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglassHalfRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "60px",
    viewBox: "0 0 45 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8AD87B2E-2DB0-4EBE-B273-5CFFB1B48AD7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MY-TRIPS---FLIGHTS-Details",
    transform: "translate(-257.000000, -2150.000000)",
    fill: "#696969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(10.000000, 1147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(214.000000, 852.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-2",
    transform: "translate(33.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hourglass-half-regular",
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.8125 C0,1.25390625 1.25390625,0 2.8125,0 L42.1875,0 C43.7460938,0 45,1.25390625 45,2.8125 C45,4.37109375 43.7460938,5.625 42.1875,5.625 L41.25,5.625 L41.25,7.8515625 C41.25,12.5742188 39.375,17.109375 36.0351562,20.4492188 L26.4726562,30 L36.0234375,39.5507812 C39.375,42.890625 41.25,47.4257812 41.25,52.1484375 L41.25,54.375 L42.1875,54.375 C43.7460938,54.375 45,55.6289062 45,57.1875 C45,58.7460938 43.7460938,60 42.1875,60 L2.8125,60 C1.25390625,60 0,58.7460938 0,57.1875 C0,55.6289062 1.25390625,54.375 2.8125,54.375 L3.75,54.375 L3.75,52.1484375 C3.75,47.4257812 5.625,42.890625 8.96484375,39.5507812 L18.5273438,30 L8.96484375,20.4492188 C5.625,17.109375 3.75,12.5742188 3.75,7.8515625 L3.75,5.625 L2.8125,5.625 C1.25390625,5.625 0,4.37109375 0,2.8125 Z M12.9492188,43.5351562 C12.4921875,43.9921875 12.0703125,44.484375 11.6953125,45 L33.3046875,45 C32.9296875,44.484375 32.5078125,43.9921875 32.0507812,43.5351562 L22.5,33.9726562 L12.9492188,43.5234375 L12.9492188,43.5351562 Z M33.3046875,15 C34.8046875,12.9375 35.625,10.4296875 35.625,7.8515625 L35.625,5.625 L9.375,5.625 L9.375,7.8515625 C9.375,10.4414062 10.1953125,12.9375 11.6953125,15 L33.3046875,15 Z",
    id: "Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassHalfRegular);
export default __webpack_public_path__ + "static/media/hourglass-half-regular.5213b3acdb26cdd0bdb4062fad8686b9.svg";
export { ForwardRef as ReactComponent };